// extracted by mini-css-extract-plugin
export default {"image-render":"yrRF54","video-render":"MxOnmQ"};